<template>
  <div>
    <h2>Relatórios</h2>

    <div
      v-for="categoria in categoriasVisiveis"
      :key="categoria.id"
      :id="categoria.id"
      class="mt-6"
    >
      <div class="d-flex flex-wrap align-center mb-4" style="gap: 12px;">
        <v-icon color="primary" large>{{ categoria.icone }}</v-icon>
        <div>
          <h3 class="mb-1">{{ categoria.titulo }}</h3>
          <p class="c-categoria__descricao mb-0">{{ categoria.descricao }}</p>
        </div>
      </div>

      <v-row class="mt-2">
        <v-col
          v-for="relatorio in categoria.relatorios"
          :key="relatorio.rota"
          cols="12"
          sm="6"
          md="4"
        >
          <v-card class="c-card" outlined>
            <v-card-title class="pb-2 c-card__titulo">
              <v-icon class="mr-3 c-card__icone" color="primary">{{ relatorio.icone }}</v-icon>
              {{ relatorio.titulo }}
            </v-card-title>

            <v-card-subtitle class="pt-0">
              {{ relatorio.descricao }}
            </v-card-subtitle>

            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" @click="$router.push(relatorio.rota)">
                Abrir
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import relatorioPermissionMixin from "@/mixins/relatorioPermissionMixin";

export default {
  name: "RelatoriosHomeView",
  mixins: [relatorioPermissionMixin],
  computed: {
    categoriasVisiveis() {
      const hash = (this.$route?.hash || "").toLowerCase();

      const filtrarRelatorios = (categoria) => ({
        ...categoria,
        relatorios: categoria.relatorios.filter(
          (r) => {
            const schemas = Array.isArray(r.schemaPermissao) ? r.schemaPermissao : [r.schemaPermissao];
            return this.relatorioTemPermissao(schemas, r.rota);
          }
        )
      });

      let categoriasFiltradas = this.categorias
        .map(filtrarRelatorios)
        .filter((c) => c.relatorios.length > 0);

      if (hash === "#financeiro") {
        return categoriasFiltradas.filter((c) => c.id === "financeiro");
      }
      if (hash === "#comercial") {
        return categoriasFiltradas.filter((c) => c.id === "comercial");
      }
      return categoriasFiltradas;
    }
  },
  data() {
    return {
      categorias: [
        {
          id: "financeiro",
          titulo: "Financeiro",
          descricao: "Relatórios financeiros para acompanhamento fiscal, títulos e movimentações.",
          icone: "mdi-cash-register",
          relatorios: [
            {
              titulo: "NF Recebida",
              descricao: "Notas fiscais recebidas com filtros e exportação.",
              rota: "/relatorios/nf-recebida",
              icone: "mdi-file-document-outline",
              schemaPermissao: ["NFRecebida", "FisDocRec", "fisdocrec"]
            },
            {
              titulo: "NF Emitida",
              descricao: "Notas fiscais emitidas com visão consolidada.",
              rota: "/relatorios/nf-emitida",
              icone: "mdi-receipt-text-outline",
              schemaPermissao: ["NFEmitida", "FisDocEmit", "fisdocemit"]
            },
            {
              titulo: "Movimento Financeiro",
              descricao: "Entradas, saídas e saldo de movimentações financeiras.",
              rota: "/relatorios/movimento-financeiro",
              icone: "mdi-cash-multiple",
              schemaPermissao: ["MovimentoFinanceiro", "FinMov", "finmov"]
            },
            {
              titulo: "Contas a Pagar",
              descricao: "Posição e detalhes de títulos a pagar.",
              rota: "/relatorios/contas-a-pagar",
              icone: "mdi-cash-clock",
              schemaPermissao: ["ContasAPagar", "FinPay", "finpay"]
            },
            {
              titulo: "Contas a Receber",
              descricao: "Títulos a receber e situação de recebimentos.",
              rota: "/relatorios/contas-a-receber",
              icone: "mdi-bank-transfer-in",
              schemaPermissao: ["ContasAReceber", "FinRec", "finrec"]
            },
            {
              titulo: "Estoque",
              descricao: "Movimentação e saldo de itens em estoque.",
              rota: "/relatorios/estoque",
              icone: "mdi-warehouse",
              schemaPermissao: ["Estoque", "Stock", "Item"]
            }
          ]
        },
        {
          id: "comercial",
          titulo: "Comercial",
          descricao: "Relatórios operacionais e comerciais para acompanhamento de orçamento, job e OS.",
          icone: "mdi-briefcase-outline",
          relatorios: [
            {
              titulo: "Solicitação de Orçamento",
              descricao: "Relatório de solicitação de orçamento.",
              rota: "/relatorios/comercial/sales-order",
              icone: "mdi-file-table-outline",
              schemaPermissao: ["SalesOrder", "SolicitacaoDeOrcamento"]
            },
            {
              titulo: "Relatório de Job",
              descricao: "Relatório de Job.",
              rota: "/relatorios/comercial/job",
              icone: "mdi-briefcase-outline",
              schemaPermissao: "Project"
            },
            {
              titulo: "Relatório de OS",
              descricao: "Relatório de Ordem de Serviço.",
              rota: "/relatorios/comercial/os",
              icone: "mdi-clipboard-text-outline",
              schemaPermissao: "Project"
            },
            {
              titulo: "Lista de Materiais",
              descricao: "Relatório de lista de materiais por OS com geração de PDF individual.",
              rota: "/relatorios/comercial/lista-materiais",
              icone: "mdi-format-list-bulleted",
              schemaPermissao: "Project"
            },
            {
              titulo: "Cronograma de JOB",
              descricao: "Relatório de cronograma de JOB com exportação em PDF e Excel.",
              rota: "/relatorios/comercial/cronograma-job",
              icone: "mdi-calendar-clock",
              schemaPermissao: "Project"
            },
            {
              titulo: "Relatório de Solicitação de Orçamento Detalhado",
              descricao: "Relatório detalhado com filtros completos e exportação em PDF/Excel.",
              rota: "/relatorios/comercial/sales-order-detalhado",
              icone: "mdi-file-document-multiple-outline",
              schemaPermissao: ["SalesOrder", "SolicitacaoDeOrcamento"]
            }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.c-card {
  height: 100%;
}

.c-card__titulo {
  min-height: 72px;
}

.c-card__icone {
  font-size: 34px !important;
}

.c-categoria__descricao {
  color: rgba(0, 0, 0, 0.6);
}
</style>
